import { Logger } from '../utils/logger';
import { Book, translateBookForTransport, translateBookFromTransport } from './Book';
import { Company } from './Company';
import { Currency } from './Currency';
import { Duration } from './Duration';
import { Edition } from './Edition';
import { Item } from './Item';
import { Product, translateProductForTransport, translateProductFromTransport } from './Product';

type ONE_EIGHTY = '180';
type THREE_SIXTY = '360';

export enum BookDuration {
  ONE_EIGHTY = '180',
  THREE_SIXTY = '360',
  LIFETIME = 'LIFETIME',
}

export enum PriceType {
  RETAIL = 'RETAIL',
  IA = 'IA',
  EA = 'EA',
}

export enum MarkupType {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export enum BookCurrency {
  USD = 'USD',
  CAD = 'CAD',
}

export interface Price extends Item {
  //type?: PriceType;
  publisherId: number;
  publisher?: Company;
  editionId: number;
  edition?: Edition;
  bookId: number;
  book?: Book;
  schoolId?: number;
  school?: Company;
  productId?: number;
  product?: Product;

  duration: Duration;
  currency: Currency;
  amount: number;
  description?: string;

  accessPriceAmount?: number;
  retailPriceAmount?: number;
}

export const displayPrice = (price?: Price) => {
  if (price?.amount && !isNaN(price.amount)) {
    return `${Number(price.amount).toFixed(2)} ${price.currency}`;
  } else {
    return '-';
  }
};

export const displayBase = (price?: Price) => {
  if (price?.amount && !isNaN(price.amount)) {
    return `${Number(price.amount).toFixed(2)} ${price.currency}`;
  } else {
    return '-';
  }
};

export const calculatePriceAmount = (baseAmount: number = 0, costAmount: number = 0): number => {
  return Number((Number(baseAmount) + Number(costAmount)).toFixed(2));
};

export const translatePriceFromTransport = (attributes: any): any => {
  const response = { ...attributes };

  if (attributes.book) {
    response.book = translateBookFromTransport(attributes.book);
  }

  if (attributes.product) {
    response.product = translateProductFromTransport(attributes.product);
  }

  return response;
};

export const translatePriceForTransport = (attributes: any): any => {
  const response = { ...attributes };

  Logger.log(`translatePriceForTransport...`);

  if (attributes.book) {
    response.book = translateBookForTransport(attributes.book);
  }

  if (attributes.product) {
    response.product = translateProductForTransport(attributes.product);
  }

  return response;
};
